import { render, staticRenderFns } from "./AmountCYSelectPage.vue?vue&type=template&id=7523d5d6&scoped=true"
import script from "./AmountCYSelectPage.vue?vue&type=script&lang=js"
export * from "./AmountCYSelectPage.vue?vue&type=script&lang=js"
import style0 from "./AmountCYSelectPage.vue?vue&type=style&index=0&id=7523d5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7523d5d6",
  null
  
)

export default component.exports